import { render } from "./InputGroup.vue?vue&type=template&id=1d2a1bc2&scoped=true"
import script from "./InputGroup.vue?vue&type=script&lang=js"
export * from "./InputGroup.vue?vue&type=script&lang=js"

import "./InputGroup.vue?vue&type=style&index=0&id=1d2a1bc2&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2a1bc2"]])

export default __exports__